export enum InfoDocumentElements {
  RawHTML = "raw-html",
  HTML = "html",
  Collapsible = "collapsible",
}
